import type React from 'react';

import { Text } from '@change/ds-core-ui';
import { cn } from '@change/ds-utils';

import { usePetitionDetailsPageData } from '#src/app/pages/petitionDetails/pageContext';
import { ResponsiveBox } from '#src/app/pages/petitionDetails/shared/components';
import { useFirstMovement, usePhoto } from '#src/app/pages/petitionDetails/shared/hooks';
import { AfterMediaWaypoint } from '#src/app/pages/petitionDetails/shared/waypoints';

import { MediaContainer } from '../../containers/Media';
import { MovementContainer } from '../../containers/Movement';

type Props = {
	showMovement?: boolean;
};

export const HeadingMobile: React.FC<Props> = ({ showMovement = true }) => {
	const {
		data: { petition: details },
	} = usePetitionDetailsPageData();
	const photo = usePhoto();
	const firstMovement = useFirstMovement();

	return (
		<div data-testid="heading-container-mobile" data-qa="heading-container-mobile">
			<div className="px-0 md:py-2">
				{!!photo && <MediaContainer key={details.id} photo={photo} />}
				<AfterMediaWaypoint />
			</div>

			<ResponsiveBox viewportSize="small">
				<div
					className={cn(
						'bg-background-base relative mx-4 mb-4 rounded-[10px] px-4 pt-4 md:mb-0 md:px-0 md:pt-10',
						photo ? '-mt-12 md:mt-0' : 'mt-0',
					)}
				>
					<Text
						as="h1"
						variant="heading"
						fontWeight="bold"
						data-qa="petition-title"
						className="text-center text-[30px] leading-[44px] font-bold break-words"
					>
						{details.ask}
					</Text>
				</div>
			</ResponsiveBox>

			{showMovement && firstMovement && (
				<div className="mb-4 px-4 md:mb-2 md:px-0">
					<MovementContainer movement={firstMovement} alwaysExpanded={!photo} />
				</div>
			)}
		</div>
	);
};
